import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useOverlayContext } from 'seagull';
import { CreateClientModal } from '~/components/CreateClientModal/CreateClientModal';
import { ManageContactModalForVendor } from '~/components/ManageContactModal';
export const useBillRecipientModals = ()=>{
    const overlayContext = useOverlayContext();
    const openCreateClient = useCallback((onCreated)=>{
        overlayContext.showModal({
            biName: 'create_client',
            openBottomSheetOnMobile: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(CreateClientModal, {
                    dismissModal: dismissModal,
                    onCreated: (clientId)=>onCreated(clientId)
                });
            }
        });
    }, [
        overlayContext
    ]);
    const openCreateContact = useCallback((onCreated)=>{
        overlayContext.showModal({
            biName: 'create_client_contact',
            closeOnEscapeKey: false,
            closeOnClickOutside: false,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ManageContactModalForVendor, {
                    onClose: (savedContact)=>{
                        dismissModal();
                        if (savedContact == null) {
                            return;
                        }
                        onCreated(savedContact.id);
                    }
                });
            }
        });
    }, [
        overlayContext
    ]);
    return {
        openCreateClient,
        openCreateContact
    };
};
